module.exports = __webpack_public_path__ + "img/mini-014.3cf42ede.jpg";